import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtilities/CommonAxios/CommonAxios";
import Sweetalert from "../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { CommonReactTable } from "../../CommonUtilities/CommonTable/CommonReactTable";
import { config } from "../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonPageHeading } from "../../CommonUtilities/CommonHeading/CommonPageHeading";
import { Field, FormikProvider, useFormik } from "formik";
import { BsEye } from "react-icons/bs";
import { viewImage } from "../../CommonUtilities/CommonFileUpload/ViewImage";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Swal from "sweetalert2";
import { FaCheck } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { FiExternalLink } from "react-icons/fi";

export default function GrieavanceReport() {

    const reportFormik = useFormik({
        enableReinitialize: true,
        initialValues: {

        },
        // validationSchema: Yup.object({
        // })
        onSubmit: (values) => {
            console.log("val>>>", values);
        }
    })
    // ******************post api *************************
    const submitDtls = async (text, values) => {
        const selectedRows = showGetScore.filter(x => x.selected);

        const invalid = selectedRows.find(
            x =>
                !x.action ||
                (x.action === "Reject" && !x.remarks.trim())
        );

        if (invalid) {
            Swal.fire(
                "Warning",
                "Please select Approve/Reject and enter remarks for rejected records.",
                "warning"
            );
            return;
        }
        else {
            Swal.fire({
                title: 'Are you sure?',
                text: `Do you want to ${text}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: `Yes, ${text} it!`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    //console.log("vvv>>>", values)
                    let res = await CommonAxiosPost(config.url.CONTEXT_URL + "grievance-update", values);
                    if (res !== undefined) {
                        if (res?.data?.scode === "01") {
                            Sweetalert(`Submitted Successfully`, "success").then(() => {
                                setModel(false);
                                getGrievanceReport();
                            });
                        } else {
                            Sweetalert(res?.data?.sdesc, "error");

                        }
                    } else {
                        Sweetalert(res?.data?.sdesc, "error");
                    }
                }
            });
        }
    }
    const [drillCount, setDrillCount] = useState(0);
    const [showGetData, setGetData] = useState([]);
    const getGrievanceReport = () => {
        let url = config.url.CONTEXT_READ_URL + "grievances-report";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                setGetData(res?.data?.data);
            } else {
                setGetData([]);
            }
        });
    };
    useEffect(() => { getGrievanceReport(); }, [])
    //***********get score api ***************** */
    const [showGetScore, setGetScore] = useState([]);
    const getScore = (candidateId) => {
        let url = config.url.CONTEXT_READ_URL + "grievances-correction-data?candidateId=" + candidateId;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                const rows = res.data.data.map((item, index) => ({
                    ...item,
                    rowIndex: index,
                    selected: false,
                    action: "",
                    remarks: item.remarks || ""
                }));

                setGetScore(rows);
            } else {
                setGetData([]);
            }
        });
    };
    const columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        // {
        //     Header: "Sl.No",
        //     id: "check",
        //     Cell: ({ row }) => (
        //         <div className="d-flex align-items-center gap-2">
        //             <input id="checkVal"
        //                 type="checkbox"
        //                 className="form-check-input"
        //              checked={formIk.values.weightageRows?.[row.index]?.selected || false}
        //             />
        //             <span>{row.index + 1}</span>
        //         </div>
        //     ),
        // },
        {
            Header: "Candidate Id",
            accessor: (rowData) => rowData?.candidate_id || "-",
        },
        {
            Header: "Candidate Name",
            accessor: (rowData) => rowData?.applicant_name || "-",
        },
        {
            Header: "Problem Type",
            accessor: (rowData) => rowData?.prblm_type || "-",
        },
        // {
        //     Header: "Corrected Data",
        //     accessor: (rowData) => rowData?.prblm_type || "-",
        // },
        // {
        //     Header: "Remarks",
        //     accessor: (rowData) => rowData?.remarks || "-",
        // },
        {
            Header: "Remarks",
            accessor: (rowData) => (
                <div
                    style={{
                        width: "200px",
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                    }}
                >
                    {rowData?.remarks || "-"}
                </div>
            ),
        },
        {
            id: "uploadedDocument",
            Header: <>Uploaded <br />Document</>,
            accessor: (rowData) =>
                rowData?.upload ? (
                    <Button
                        type="button"
                        className="btn btn-primary btn-sm no-print"
                        onClick={() => viewImage(rowData.upload)}
                    >
                        <BsEye />
                    </Button>
                ) : (
                    "-"
                ),
        },
        {
            Header: "Status",
            accessor: (row) => (
                <span
                    style={{
                        color: row?.status === "Verified" ? "green" : "inherit",
                        fontWeight: row?.status === "Verified" ? "bold" : "normal",
                    }}
                >
                    {row?.status || "-"}
                </span>
            ),
        },
        {
            Header: "Action",
            accessor: (rowData) =>
                rowData?.prblm_type === "Other" ? (<React.Fragment>
                    <Button
                        type="button"
                        className="border-0"
                        style={{
                            background: "#e8f5e9",
                            color: "#2e7d32",
                            fontWeight: 600,
                            borderRadius: "20px",
                            padding: "4px 14px"
                        }}
                        // className="btn btn-success btn-sm no-print"
                        onClick={() =>
                            submitDtls("Approve", { candidateId: rowData?.candidate_id, status: rowData?.status })
                        }
                    >
                        <FaCheck className="me-1" />  Approve
                    </Button> &nbsp;
                    <Button
                        type="button"
                        className="border-0 ms-2"
                        style={{
                            background: "#ffebee",
                            color: "#c62828",
                            fontWeight: 600,
                            borderRadius: "20px",
                            padding: "4px 14px"
                        }}
                        // className="btn btn-danger btn-sm no-print"
                        onClick={() =>
                            submitDtls("Reject", { candidateId: rowData.candidate_id, status: rowData?.status })
                        }
                    >
                        <FaTimes className="me-1" /> Reject
                    </Button>
                </React.Fragment>) :
                    rowData?.prblm_type === "Score" ? (
                        <Button
                            type="button"
                            //className="btn  btn-sm no-print"
                            variant="outline-primary"
                            className="border shadow-sm px-2 no-print"
                            size="sm"
                            title="View Details"
                            onClick={() => { getScore(rowData?.candidate_id); setModel(true); setSelectedCandidate(rowData); }}
                        >
                            <FiExternalLink size={17} /> Open Grievance Details
                        </Button>
                    ) :
                        ("-"),
        },
    ]

    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showModel, setModel] = useState(false);
    const handleClose = () => {
        setModel(false); setSelectedCandidate(null);
    };


    const columns2 = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        // {
        //     Header: (
        //         showGetScore.some(item => item.status !== null) ? (
        //             <span>Sl.No</span>
        //         ) : (
        //             <div className="d-flex align-items-center gap-2">
        //                 <input
        //                     type="checkbox"
        //                     className="form-check-input"
        //                     checked={
        //                         showGetScore.length > 0 &&
        //                         showGetScore.every(item => item.selected)
        //                     }
        //                     onChange={(e) => {
        //                         const checked = e.target.checked;

        //                         setGetScore(prev =>
        //                             prev.map(item => ({
        //                                 ...item,
        //                                 selected: checked,
        //                                 action: checked ? item.action : "",
        //                                 remarks: checked ? item.remarks : ""
        //                             }))
        //                         );
        //                     }}
        //                 />
        //                 <span>Sl.No</span>
        //             </div>
        //         )
        //     ),
        //     id: "select",
        //     Cell: ({ row }) => (
        //         <div className="d-flex align-items-center gap-2">
        //             {row.original?.status === null ? (
        //                 <input
        //                     type="checkbox"
        //                     className="form-check-input"
        //                     checked={showGetScore[row.index]?.selected || false}
        //                     onChange={(e) => {
        //                         const temp = [...showGetScore];

        //                         temp[row.index].selected = e.target.checked;

        //                         if (!e.target.checked) {
        //                             temp[row.index].action = "";
        //                             temp[row.index].remarks = "";
        //                         }

        //                         setGetScore(temp);
        //                     }}
        //                 />
        //             ) : null}
        //             <span>{row.index + 1}</span>
        //         </div>
        //     ),
        // },
        {
            Header: "Course",
            accessor: (row) => row?.qual_level || "-",
        },
        {
            Header: "Actual %",
            accessor: (row) => row?.ssc_percentage || "-",
        },
        {
            Header: "Corrected %",
            accessor: (row) => row?.correction || "-",
        },
        {
            Header: "Action",
            accessor: (row) => {
                // if (row.status !== null) {
                const isProcessed =
                    row.status === "Approved" || row.status === "Rejected";

                if (isProcessed) {
                    return (
                        <div
                            style={{
                                width: "220px",
                                maxWidth: "220px",
                                whiteSpace: "normal",
                                wordBreak: "break-word"
                            }}
                        >
                            <div
                                className={`fw-bold ${row.status === "Approved"
                                    ? "text-success"
                                    : row.status === "Rejected"
                                        ? "text-danger"
                                        : "text-warning"
                                    }`}
                            >
                                {row.status}
                            </div>
                            {(row.status === "Rejected" && row.remarks) && (
                                <div
                                    className="mt-1"
                                    style={{
                                        width: "300px",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word",
                                        fontSize: "12px"
                                    }}
                                >
                                    <b>Remarks:</b>
                                    <br />
                                    {row.remarks}
                                </div>
                            )}
                        </div>
                    );
                }
                return (
                    <>
                        <div className="d-flex align-items-center gap-3">
                            <label>
                                <input
                                    type="radio"
                                    name={`action_${row.rowIndex}`}
                                    value="Approved"
                                    //disabled={!row.selected}
                                    //checked={row.action === "Approved"}
                                    onChange={(e) => {
                                        setGetScore(prev =>
                                            prev.map(item =>
                                                //  item.rowIndex === row.rowIndex
                                                item.qualification_id === row.qualification_id
                                                    ? {
                                                        ...item,
                                                        action: e.target.value,
                                                        remarks:
                                                            e.target.value === "Approved"
                                                                ? ""
                                                                : item.remarks
                                                    }
                                                    : item
                                            )
                                        );
                                    }}
                                />
                                &nbsp;Approve
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name={`action_${row.rowIndex}`}
                                    value="Rejected"
                                    //  disabled={!row.selected}
                                    //checked={row.action === "Rejected"}
                                    onChange={(e) => {
                                        setGetScore(prev =>
                                            prev.map(item =>
                                                //item.rowIndex === row.rowIndex
                                                item.qualification_id === row.qualification_id
                                                    ? {
                                                        ...item,
                                                        action: e.target.value,
                                                        remarks:
                                                            e.target.value === "Rejected"
                                                                ? ""
                                                                : item.remarks
                                                    }
                                                    : item
                                            )
                                        );
                                    }}
                                />
                                &nbsp;Reject
                            </label>
                        </div>
                        {/* row.selected && */}
                        {row.action === "Rejected" && (
                            <textarea
                                className="form-control mt-2"
                                rows={2}
                                placeholder="Enter Remarks"
                                maxLength={500}
                                value={row.remarks}
                                onChange={(e) => {
                                    const temp = [...showGetScore];
                                    temp[row.rowIndex].remarks = e.target.value;
                                    setGetScore(temp);
                                }}
                            />
                        )}
                    </>
                );
            }
        }

    ]
    // const allProcessed = showGetScore.every(item => item.status !== null);
    const allProcessed = showGetScore.every(
        item => item.status === "Approved" || item.status === "Rejected"
    );
    return (

        <React.Fragment>
            <Modal show={showModel} onHide={handleClose} centered size="xl" className="kgbv-gomodal">
                <Modal.Header closeButton className="kgbv-modalheader">
                    <Modal.Title className="kgbv-gomodaltitle">Corrected Grieavance Status Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className="kgbv-modalbody">

                    {selectedCandidate && (
                        <Card className="shadow-sm border-0 mb-3">
                            <Card.Body className="py-3">

                                <Row>
                                    <Col md={3}>
                                        <label className="fw-bold text-secondary">
                                            Candidate ID
                                        </label>
                                        <div className="mt-1">
                                            {selectedCandidate.candidate_id}
                                        </div>
                                    </Col>

                                    <Col md={3}>
                                        <label className="fw-bold text-secondary">
                                            Candidate Name
                                        </label>
                                        <div className="mt-1">
                                            {selectedCandidate.applicant_name}
                                        </div>
                                    </Col>

                                    <Col md={3}>
                                        <label className="fw-bold text-secondary">
                                            Dob
                                        </label>
                                        <div className="mt-1">
                                            {selectedCandidate.dob}
                                        </div>
                                    </Col>

                                    <Col md={3}>
                                        <label className="fw-bold text-secondary">
                                            Gender
                                        </label>
                                        <div className="mt-1">
                                            {selectedCandidate.gender}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col md={3}>
                                        <label className="fw-bold text-secondary">
                                            Mobile
                                        </label>
                                        <div className="mt-1">
                                            {selectedCandidate.mobile_no}
                                        </div>
                                    </Col>

                                    <Col md={6}>
                                        <label className="fw-bold text-secondary">
                                            Remarks
                                        </label>
                                        <div
                                            className="mt-1"//p-2 border rounded bg-light
                                            style={{
                                                width: "450px",
                                                whiteSpace: "pre-wrap",
                                                wordBreak: "break-word",
                                                overflowWrap: "break-word",
                                                fontSize: "12px"
                                            }}
                                        // style={{
                                        //     fontSize: "13px",
                                        //     lineHeight: "1.4",
                                        //     maxHeight: "90px",
                                        //     overflowY: "auto",
                                        //     whiteSpace: "pre-wrap",
                                        //     wordBreak: "break-word",
                                        // }}
                                        >
                                            {selectedCandidate?.remarks || "-"}
                                        </div>
                                    </Col>

                                    <Col md={3} className="d-flex align-items-end justify-content-end" >
                                        {selectedCandidate.upload ? (
                                            <Button variant="primary" size="sm"
                                                onClick={() => viewImage(selectedCandidate.upload)}
                                            >
                                                <BsEye className="me-1" /> View Document
                                            </Button>
                                        ) : (
                                            <span className="text-muted"> No Document </span>
                                        )}
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    )}

                    {showGetScore?.length > 0 && (
                        <CommonReactTable
                            tableid="addigned-cand"
                            pagination="false"
                            data={showGetScore}
                            columns={columns2}
                            serachAlign="left"
                            isBack={false}
                            headColumCount={8}
                            paginationCount="All"
                            search="true"
                            showFooter="false"
                            filename="Corrected Grieavance Status Data"
                            excelFlag={false}
                        />
                    )}

                    {!allProcessed && (
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                variant="success"
                                onClick={() => {

                                    // const selectedRows = showGetScore.filter(x => x.selected);
                                    //const pendingRows = showGetScore.filter(x => x.status === null);
                                    const pendingRows = showGetScore.filter(
                                        x => x.status === "Pending"
                                    );

                                    // if (selectedRows.length === 0) {
                                    //     Swal.fire("Warning", "Please select at least one record.", "warning");
                                    //     return;
                                    // }

                                    // const invalid = selectedRows.find(
                                    //     x =>
                                    //         !x.action ||
                                    //         (x.action === "Reject" && !x.remarks?.trim())
                                    // );
                                    const invalid = pendingRows.find(
                                        x =>
                                            !x.action ||
                                            (x.action === "Rejected" && !x.remarks.trim())
                                    );

                                    if (invalid) {
                                        Swal.fire(
                                            "Warning",
                                            "Please select Approve/Reject for all pending records and enter remarks for rejected records.",
                                            "warning"
                                        );
                                        return;
                                    }

                                    const payload = {
                                        //selectedRows
                                        candidateId: selectedCandidate.candidate_id,
                                        grievanceList: pendingRows.map(item => ({
                                            course: item.qualification_id,
                                            qualLevel: item.qual_level,
                                            actualPercentage: item.ssc_percentage,
                                            correctedPercentage: item.correction,
                                            action: item.action,
                                            remarks: item.remarks
                                        }))
                                    };

                                    submitDtls("Submit", payload);
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <CommonPageHeading heading="Grievance Status Report" />
            <FormikProvider value={reportFormik}>
                <Form className="form-section" onSubmit={reportFormik.handleSubmit} onChange={reportFormik.handleChange} >
                    <div className="table-responsive mt-3">
                        {showGetData?.length > 0 &&
                            <CommonReactTable
                                tableid="addigned-cand"
                                pagination="false"
                                data={showGetData}
                                columns={columns}
                                serachAlign="left"
                                isBack={false}
                                headerName={<>Grievance Status Report</>}
                                headColumCount={8}
                                paginationCount="All"
                                search="true"
                                showFooter="false"
                                filename="Grievance Status Report"
                            />
                        }
                    </div>
                </Form>
            </FormikProvider>
        </React.Fragment>
    )
}
